let localeResult

// Get locale from url
const getLocale = (urlString, cached = true) => {
  if (!cached) {
    localeResult = ''
  }

  if (localeResult && cached) { // Return cached result if getLocale is already called
    return localeResult
  }

  const url = new URL(urlString)
  const path = url.pathname
  let brand = process.env.VUE_APP_BRAND

  const locales = {
    'zava': {
      '/uk/': 'en_GB',
      '/ie/': 'en_IE',
      '/de/': 'de_DE',
      '/fr/': 'fr_FR',
      '/es/': 'es_ES',
      '/it/': 'it_IT'
    },
    'superdrug': {
      '/ie/': 'sd_IE'
    },
    'asda': {
      '/uk': 'as_AS'
    }
  }

  Object.keys(locales[brand]).forEach((key) => {
    if (path.includes(key)) {
      localeResult = locales[brand][key]
    }
  })

  if (!localeResult) { // We assume if there is no locale in the url, it is superdrug
    localeResult = 'sd_SD'
  }

  return localeResult
}

export default getLocale
